'use client'

import * as React from 'react'
import type { ColorResult, Color } from 'react-color'
import { SketchPicker } from 'react-color'
import { Divider } from 'components/divider'

import { SearchableFilters } from '@web/components/content-api/search-page/utils'
import { FilterAccordion } from './accordion'
import { useSearchPageContext } from '@web/components/algolia/providers/content-api-search-page-provider'

interface ColorPickerFilterProps {
  header: string
  resetText: string
}

export function ColorPickerFilter({ header, resetText }: ColorPickerFilterProps) {
  const { color, updateColor, expanded } = useSearchPageContext()
  const [localColor, setLocalColor] = React.useState<Color | undefined>(color ? color : undefined)

  const updateAlgoliaWithColor = (col: ColorResult | undefined) => {
    updateColor(col?.hex || null)
  }

  const handleColorChangeComplete = (col: ColorResult) => {
    handleColorChange(col)
    updateAlgoliaWithColor(col)
  }

  const handleColorChange = (col: ColorResult) => {
    setLocalColor(col.hex)
  }

  const handleColorPickerReset = () => {
    updateColor(null)

    if (typeof window === 'undefined') {
      return
    }

    updateAlgoliaWithColor(undefined)
  }

  return (
    <>
      <FilterAccordion
        header={header}
        expanded={expanded ? expanded.includes(SearchableFilters.COLORS) : undefined}
      >
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-end hover:cursor-pointer">
            <span className="text-14 cursor-pointer underline" onClick={handleColorPickerReset}>
              {resetText}
            </span>
          </div>
          <div className="flex w-full flex-col gap-[10px]">
            <SketchPicker
              disableAlpha={true}
              color={localColor}
              presetColors={[
                '#D0021B',
                '#F5A623',
                '#F8E71C',
                '#8B572A',
                '#7ED321',
                '#417505',
                '#BD10E0',
                '#9013FE',
                '#4A90E2',
                '#150DE8',
                '#50E3C2',
                '#B8E986',
                '#000000',
                '#4A4A4A',
                '#9B9B9B',
                '#FFFFFF',
              ]}
              onChange={handleColorChange}
              width="100%"
              onChangeComplete={handleColorChangeComplete}
              className="!box-border !shadow-none"
            />
          </div>
        </div>
      </FilterAccordion>
      <Divider className="relative left-[-20px] w-[calc(100%+40px)] bg-[#DFDDE5]" />
    </>
  )
}
